/**
 * debugPanelVisibility — P6-15 hide debug sidebar by default; ?debug=1 or F2.
 */

import { isDebugClientSearch } from './productClientGate.js';

export const DEBUG_PANEL_STORAGE_KEY = 'lol_debug_panel';

export function shouldShowDebugPanel(search = '', storage = null) {
  if (isDebugClientSearch(search)) return true;
  if (storage && typeof storage.getItem === 'function') {
    return storage.getItem(DEBUG_PANEL_STORAGE_KEY) === '1';
  }
  return false;
}

export function applyDebugPanelVisibility(panelEl, visible) {
  if (!panelEl) return;
  panelEl.hidden = !visible;
  if (panelEl.style) {
    panelEl.style.display = visible ? 'flex' : 'none';
  }
}

export function wireDebugPanelVisibility(doc = document, opts = {}) {
  const panel = doc.getElementById('debug-panel');
  if (!panel) return null;
  const storage = opts.storage || (typeof localStorage !== 'undefined' ? localStorage : null);
  const search = opts.search !== undefined && opts.search !== null
    ? opts.search
    : (typeof location !== 'undefined' ? location.search : '');
  let visible = shouldShowDebugPanel(search, storage);
  applyDebugPanelVisibility(panel, visible);

  function setVisible(next) {
    visible = Boolean(next);
    applyDebugPanelVisibility(panel, visible);
    if (storage && typeof storage.setItem === 'function') {
      storage.setItem(DEBUG_PANEL_STORAGE_KEY, visible ? '1' : '0');
    }
  }

  function toggle() {
    setVisible(!visible);
  }

  const onKey = (e) => {
    if (e.key === 'F2') {
      e.preventDefault();
      toggle();
    }
  };
  if (typeof doc.addEventListener === 'function') {
    doc.addEventListener('keydown', onKey);
  }

  if (typeof window !== 'undefined') {
    window.__debugShowPanel = setVisible;
    window.__debugTogglePanel = toggle;
  }

  return { setVisible, toggle, isVisible: () => visible };
}
